import { cn } from "../../../utils/cn";
import { TableCell } from "../../atoms/table";

export function DataTableCell({
  children,
  columnSize,
  className,
  ...props
}: React.TdHTMLAttributes<HTMLTableCellElement> & {
  isResponsive?: boolean;
  innerClassName?: string;
  columnSize: string | number;
}) {
  const style: React.CSSProperties = {
    position: "relative",
    width: columnSize,
    paddingRight: "1.25rem",
  };

  return (
    <TableCell
      style={style}
      className={cn("first-of-type:pl-4", className)}
      {...props}
    >
      {children}
    </TableCell>
  );
}
